<template>
  <div :class="['content-box', { 'no-card': disableCard }]">
    <div class="m-2 pl-3 text-center" v-show="isLoading">
      <font-awesome-icon
        :icon="['fa', 'circle-notch']"
        class="fa-spin m-auto spinner fa-5x egx-partner-color"
      />
    </div>
    <div :class="['card-body', { 'no-card': disableCard }]" v-show="!isLoading">
      <span class="egx-partner-color">
        <h2 v-safe-html="pageConfiguration.title" />
      </span>
      <div v-safe-html="pageConfiguration.main_instructions" />
      <OfferCard class="mt-4" @number-of-programs="updateProgramsSize" :publicPage="publicPage"/>
      <div class="d-flex justify-content-center">
        <button
          @click="redirect(fulfill_sync_details.pages?.offers?.view_button.path);"
          :class="fulfill_sync_details.pages?.offers?.view_button.class"
          :style="fulfill_sync_details.pages?.offers?.view_button.style"
          v-if="fulfill_sync_details.pages?.offers?.view_button && totalPrograms == 0"
        >
          {{ fulfill_sync_details.pages?.offers?.view_button.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OfferCard from './OfferCard.vue';
import router from '../router';

export default {
  components: {
    OfferCard,
  },

  props: {
    publicPage: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      disableCard: false,
      totalPrograms: 1,// Let it as 1 to not show the button, this will be updated when the program finishes loading
      pageConfiguration: {},
      isLoading: false,
    };
  },

  created() {
    this.isLoading = true;
    // Fetching the page configuration from the store
    this.$store.dispatch('fulfill_integrate/getPagePublicConfiguration', {
      task_name: 'availableprograms',
    })
    .then((response) => {
      this.pageConfiguration = response;
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  computed: {
    fulfill_sync_details() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details;
    },
  },

  methods: {
    redirect(path) {
      router.push({ path});
    },

    updateProgramsSize(size) {
      this.isLoading = true;
      this.totalPrograms = size;
      this.isLoading = false;
    }
  },
}
</script>
